@if (navigationLinkName.length > 0) {
    <span class="cursor-pointer d-inline-flex align-items-center gap-1" (click)="navigate()">
        <fa-icon [icon]="faChevronLeft"></fa-icon>
        <span>{{ navigationLinkName }}</span>
    </span>
}
